import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiX, FiPlay } = FiIcons;

const DemoVideoModal = ({ onClose }) => {
  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        {/* Backdrop */}
        <motion.div
          className="absolute inset-0 bg-black/80"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        />

        {/* Modal */}
        <motion.div
          className="relative bg-white rounded-2xl shadow-2xl max-w-4xl w-full"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
          transition={{ type: "spring", duration: 0.5 }}
        >
          {/* Close Button */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 z-10 w-10 h-10 bg-black/20 hover:bg-black/40 rounded-full flex items-center justify-center text-white transition-colors"
          >
            <SafeIcon icon={FiX} className="w-6 h-6" />
          </button>

          {/* Video Container */}
          <div className="aspect-video bg-slate-900 rounded-2xl overflow-hidden">
            {/* Placeholder for demo video */}
            <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-indigo-600 to-purple-700">
              <div className="text-center text-white">
                <div className="w-24 h-24 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6">
                  <SafeIcon icon={FiPlay} className="w-12 h-12 ml-1" />
                </div>
                <h3 className="text-2xl font-semibold mb-2">Live Product Demo</h3>
                <p className="text-white/80 max-w-md mx-auto">
                  See how Instashortlist transforms your hiring process in this 3-minute walkthrough
                </p>
              </div>
            </div>
          </div>

          {/* Video Info */}
          <div className="p-6">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="font-semibold text-lg text-slate-900">
                  Instashortlist Platform Demo
                </h3>
                <p className="text-slate-600">
                  Complete walkthrough of AI-powered recruitment
                </p>
              </div>
              <div className="text-sm text-slate-500">
                Duration: 3:24
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default DemoVideoModal;